import { useId } from 'react';
import { FormLabel, Stack, TextField, type TextFieldProps } from '@mui/material';

export type FormFieldProps = Omit<TextFieldProps, 'label'> & { label: string };

/** TextField with the label above the input, as in the design system. */
export function FormField({ label, id, sx, slotProps, ...props }: FormFieldProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const labelId = `${inputId}-label`;
  return (
    <Stack spacing={1} sx={sx}>
      <FormLabel id={labelId} htmlFor={inputId} error={props.error}>
        {label}
      </FormLabel>
      <TextField
        id={inputId}
        fullWidth
        {...props}
        // A select is a button, not an input: name it through the label's id.
        slotProps={
          props.select
            ? { ...slotProps, select: { labelId, ...(slotProps?.select as object | undefined) } }
            : slotProps
        }
      />
    </Stack>
  );
}
